import React from 'react';
import MuiPaper from '@mui/material/Paper';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';

interface IProps {
  title?: string;
  children?: React.ReactNode;
  elevation?: number;
  square?: boolean;
  ref?: (ref: any) => void;
  style?: React.CSSProperties;
  testid?: string;
  className?: string;
  classes?: Partial<Record<keyof ReturnType<typeof styles>, string>>;
}

const styles = (theme: Theme) => ({
  /** Styles applied to the root element */
  root: {},
  /** Styles applied to the root element if square={false} */
  rounded: {},
});

/**
 * Används som en container för annat content
 */
export const EDPaper = React.forwardRef(
  (props: IProps, ref: React.Ref<never>) => (
    <MuiPaper
      ref={ref}
      title={props.title}
      square={props.square != null ? props.square : true}
      elevation={props.elevation ? props.elevation : 0}
      className={props.className}
      classes={props.classes}
      style={props.style}
      data-testid={props.testid}
    >
      {props.children}
    </MuiPaper>
  )
);

export default withStyles(EDPaper, styles);
